module.exports = __webpack_public_path__ + "img/icon-competence-6.2cf35335.svg";